import React from 'react';
import WordMaster from '../games/WordMaster/WordMaster';
import AdPlaceholder from '../components/AdPlaceholder';
import SeoHead from '../components/SeoHead';
import './WordMasterPage.css';

export default function WordMasterPage() {
  return (
    <main className="word-master-page">
      <SeoHead
        title="Word Master"
        description="Play Word Master – Wordle-style daily 5-letter word puzzle. Same word for everyone. 6 guesses. Track streaks and compete on the leaderboard."
        path="/word-master"
      />
      <div className="game-page-ad">
        <AdPlaceholder variant="game-top" />
      </div>
      <WordMaster />
    </main>
  );
}
